// Click Proxy
for (const entry of document.querySelectorAll('.kem-evententry')) {
    entry.addEventListener('click', (evt) => {
        const anchor = evt.target.closest('a');
        if (anchor) return;
        const eventEntry = evt.target.closest('.kem-evententry');
        const eventEntryLink = eventEntry?.querySelector('a.kem-evententry__link');
        const link = eventEntryLink?.href;
        if (!link || !eventEntry || !eventEntryLink) return;
        
        // make sure that the link opens in a new tab, if target _blank is set
        if (eventEntryLink.target === '_blank') {
            window.open(link, '_blank');
            return;
        }

        if (link) window.location = link;
    });
}